
import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router';

const ListingPage = lazy(() => import('./pages/ListingPage'));
const SingleBlogPage = lazy(() => import('./pages/SingleBlogPage'));

export const blogsRoutes: routeItem[] = [
  {
    path: 'academy',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <ListingPage />,
      },
      {
        path: ':slug',
        element: <SingleBlogPage />,
        
      }
    ],
  },
  
];